import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Box,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const AddCourseModal = ({
    showadd,
    handleCloseAdd,
    lngsltd,
    coursename,
    handleCourseNameChange,
    courseNameError,
    coursedes,
    setCourseDes,
    grpName,
    setGrpName,
    groupData,
    grpNameError,
    handleSave
}) => {
    // Ensure groupData is always an array
    const safeGroupData = Array.isArray(groupData) ? groupData : [];
    return (
        <Dialog open={showadd} onClose={handleCloseAdd} fullWidth maxWidth="sm">
            <DialogTitle sx={{ backgroundColor: '#efedf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {lngsltd["Add Course"]}
                <IconButton onClick={handleCloseAdd} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Course Name Field */}
                <Box mb={3}>
                    <TextField
                        label={
                            <Box component="span">
                                {lngsltd["Course Name"]}:
                                <Box component="span" color="error.main">
                                    *
                                </Box>
                            </Box>
                        }
                        placeholder={lngsltd["Enter Course Name"]}
                        fullWidth
                        value={coursename}
                        onChange={handleCourseNameChange}
                        error={Boolean(courseNameError)}
                        helperText={courseNameError}
                    />
                </Box>

                {/* Description Field */}
                <Box mb={3}>
                    <TextField
                        label={`${lngsltd["Description"]}:`}
                        placeholder={lngsltd["Enter Course Description"]}
                        fullWidth
                        value={coursedes}
                        onChange={(e) => setCourseDes(e.target.value)}
                    />
                </Box>

                {/* Select Group Field */}
                <Box mb={3}>
                    <FormControl fullWidth error={Boolean(grpNameError)}>
                        <InputLabel>
                            <Box component="span">
                                {lngsltd["Select Group"]}:
                                <Box component="span" color="error.main">
                                    *
                                </Box>
                            </Box>
                        </InputLabel>
                        <Select
                            value={grpName}
                            onChange={(e) => setGrpName(e.target.value)}
                            label={lngsltd["Select Group"]}
                        >
                            <MenuItem value="" disabled>
                                {lngsltd["Select Group"]}
                            </MenuItem>
                            {safeGroupData.map((group) => (
                                <MenuItem key={group.groupID} value={group.groupName}>
                                    {group.groupName}
                                </MenuItem>
                            ))}
                        </Select>
                        {grpNameError && (
                            <FormHelperText>{grpNameError}</FormHelperText>
                        )}
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    {lngsltd["Add"]}
                </Button>
                <Button variant="outlined" color='error' onClick={handleCloseAdd}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
};